import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useScrollToSection } from "../hooks/useScrollToSection.js";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loansOpen, setLoansOpen] = useState(false);
  const loansDropdownRef = useRef(null);
  const scrollToSection = useScrollToSection();

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const toggleLoans = () => {
    setLoansOpen((prev) => !prev);
  };

  // Close loans dropdown when clicking or touching outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        loansDropdownRef.current &&
        !loansDropdownRef.current.contains(event.target)
      ) {
        setLoansOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLoansOpen(false);
  }, [location]);

  return (
    <>
      <div className="top-bar">
        <a href="tel:+2349037614599" style={{ color: 'white', textDecoration: 'none', marginRight: '10px' }}>+234 903 761 4599</a>
        |
        <a href="tel:+2347049146443" style={{ color: 'white', textDecoration: 'none', marginLeft: '10px' }}>+234 704 914 6443</a>
      </div>

      <header className="navbar">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img src="/assets/logo.png" alt="Respected Solutions Logo" />
            </Link>
          </div>

          <div className="mobile-menu">
            <div className="hamburger" onClick={toggleMenu}>
              ☰
            </div>
          </div>

          <div className={`nav-links-container ${menuOpen ? "show" : ""}`}>
            <nav>
              <ul className="hamburger-list">
                <li>
                  <Link
                      to="/"
                      onClick={() => {
                        scrollToSection("home");
                        setMenuOpen(false);
                      }}
                  >
                    Home
                  </Link>
                </li>

                <li className="loans-dropdown" ref={loansDropdownRef}>
                  <span className="loans-dropdown-toggle" onClick={toggleLoans}>
                    What We Offer ▼
                  </span>
                  {loansOpen && (
                      <ul className="loans-dropdown-menu">
                        <li>
                          <Link
                              to="/loan-against-cars"
                              onClick={() => {
                                setMenuOpen(false);
                                setLoansOpen(false);
                              }}
                          >
                            Loan Against Cars
                          </Link>
                        </li>
                        <li>
                          <Link
                              to="/loan-against-jewelry"
                              onClick={() => {
                                setMenuOpen(false);
                                setLoansOpen(false);
                              }}
                          >
                            Loan Against Jewelry
                          </Link>
                        </li>
                        <li>
                          <Link
                              to="/loan-against-luxury-watches"
                              onClick={() => {
                                setMenuOpen(false);
                                setLoansOpen(false);
                              }}
                          >
                            Loan Against Luxury Watches
                          </Link>
                        </li>
                      </ul>
                  )}
                </li>

                <li>
                  <Link
                      to="/"
                      onClick={() => {
                        scrollToSection("about");
                        setMenuOpen(false);
                      }}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/blogs" onClick={() => setMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" onClick={() => setMenuOpen(false)}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>

            <button
                className="btn-get-started"
                onClick={() => {
                  navigate("/contact-us");
                }}
            >
              Get Started
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
